import { render, staticRenderFns } from "./DashersCoinVsWithdrawn.vue?vue&type=template&id=03710271&scoped=true"
import script from "./DashersCoinVsWithdrawn.vue?vue&type=script&lang=js"
export * from "./DashersCoinVsWithdrawn.vue?vue&type=script&lang=js"
import style0 from "./DashersCoinVsWithdrawn.vue?vue&type=style&index=0&id=03710271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03710271",
  null
  
)

export default component.exports